import { alpha, styled } from '@mui/material/styles';
import { Box, List } from 'components/ui';
import { selectionPinButtonClasses } from 'pages/Auth/components/SelectionPinButton/SelectionPinButton.styles';

export const RootPaper = styled(Box)(({ theme }) => ({
  boxSizing: 'border-box',
  maxHeight: '100vh',
  maxWidth: 600,
  padding: theme.spacing(3),
  width: '100%',

  '& h2': {
    marginBottom: theme.spacing(2),
    marginTop: theme.spacing(1),
  },
  '& .scar-textField': {
    marginBottom: theme.spacing(2),
  },
}));

export const FirmListContainer = styled(List)(({ theme }) => ({
  backgroundColor: 'transparent',
  boxSizing: 'border-box',
  marginLeft: `-${theme.spacing(1)}px`,
  marginRight: `-${theme.spacing(1)}px`,
  maxHeight: 'calc(100vh - 150px)',
  overflow: 'hidden',
  overflowY: 'auto',

  '& .MuiListItem-root': {
    backgroundColor: 'transparent',
    borderBottom: 'none',
    borderTop: 'none',
    transition: theme.transitions.create(['background-color'], {
      duration: theme.transitions.duration.shorter,
    }),
    '&:hover': {
      backgroundColor: alpha(theme.palette.primary.main, 0.08),
    },
    '&:focus-within': {
      backgroundColor: alpha(theme.palette.primary.main, 0.12),
    },
    '&:active': {
      backgroundColor: alpha(theme.palette.primary.main, 0.1),
    },
    [`&:hover .${selectionPinButtonClasses.outlinedIcon}, &:focus-within .${selectionPinButtonClasses.outlinedIcon}`]: {
      opacity: 1,
    },
  },

  '& .MuiListItem-divider': {
    borderBottom: 'none',
  },
}));
